export default {
  title: 'Settings',

  errors: {
    componentNotFound: 'Component for key <b>{key}</b> not found.'
  }
}
